import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import { TransactionalSolidButton, SecondaryTextButton } from '@bibliocommons/base-buttons';

import './FullScreenOverlayFooter.scss';

function close() {
  window.history.back();
}

export default function FullScreenOverlayFooter({
  className,
  disabled,
  isLoading,
  primaryActionButtonTag,
  primaryActionButtonText,
  handlePrimaryAction,
  renderPrimaryAction,
  renderSecondaryAction,
  size
}) {
  const classNames = cn('cp-full-screen-overlay-footer', className);
  const PrimaryActionButtonTag = primaryActionButtonTag || TransactionalSolidButton;
  const contentWrapper = cn('full-screen-overlay-footer__wrapper', `full-screen-overlay-footer__wrapper--${size}`);

  const button = renderPrimaryAction ? (
    renderPrimaryAction()
  ) : (
    <PrimaryActionButtonTag
      className="full-screen-overlay__footer__primary-button"
      dataKey="full-screen-overlay-primary-button"
      disabled={disabled}
      isLoading={isLoading}
      handleClick={handlePrimaryAction}
    >
      {primaryActionButtonText}
    </PrimaryActionButtonTag>
  );
  const secondaryButton = renderSecondaryAction ? (
    renderSecondaryAction()
  ) : (
    <SecondaryTextButton
      className="full-screen-overlay__footer__secondary-button"
      dataKey="full-screen-overlay-secondary-button"
      handleClick={close}
    >
      <FormattedMessage id="button_cancel" />
    </SecondaryTextButton>
  );

  return (
    <footer className={classNames}>
      <div className={contentWrapper}>
        {secondaryButton}
        {button}
      </div>
    </footer>
  );
}

FullScreenOverlayFooter.defaultProps = {
  size: 'default'
};

FullScreenOverlayFooter.propTypes = {
  className: PropTypes.string,
  primaryActionButtonTag: PropTypes.elementType,
  primaryActionButtonText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  handlePrimaryAction: PropTypes.func,
  renderPrimaryAction: PropTypes.func,
  renderSecondaryAction: PropTypes.func,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['default', 'small', 'medium'])
};
